export default function Spinner(){
  return {
    restrict: "E",
    template: require("./Spinner.html")
  }
}


// WEBPACK FOOTER //
// ./src/util/Spinner.js